module.exports = __webpack_public_path__ + "img/image-020.bc5cb922.png";